import { jsx as e } from "react/jsx-runtime";
import { u as a } from "../styled-components.browser.esm-3eb04950.js";
import { IconContainer as i } from "../IconContainer.js";
import * as o from "react";
import { l as n } from "../lodash-fd177a50.js";
function l(r, t) {
  return /* @__PURE__ */ o.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, r), /* @__PURE__ */ o.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
    clipRule: "evenodd"
  }));
}
const s = o.forwardRef(l), g = s, u = (r) => /* @__PURE__ */ e(c, { ...n.omit(r, ["isDragging"]), $isdragging: r.isDragging, children: /* @__PURE__ */ e(i, { size: 14, color: "var(--light-grey)", children: /* @__PURE__ */ e(g, {}) }) }), c = a.div`
  vertical-align: bottom;
  display: inline-block;
  height: 100%;

  svg {
    width: 100%;
    height: 100%;
  }

    cursor: ${({ $isdragging: r }) => r ? "grabbing" : "move"};
`;
export {
  u as default
};
//# sourceMappingURL=SortHandle.js.map
